// Pure helper for AutoParser's queue-result messaging (#42). Lives outside the
// component so it can be unit-tested without rendering AutoParser.

export interface QueueFailure {
  repo: string;
  message: string;
}

export type QueueResult =
  | { kind: 'success'; text: string }
  | { kind: 'partial'; text: string; failures: QueueFailure[] }
  | { kind: 'error'; text: string; failures: QueueFailure[] };

export function buildQueueResultMessage(total: number, failures: QueueFailure[]): QueueResult {
  const failed = failures.length;
  const succeeded = total - failed;
  if (failed === 0) {
    return { kind: 'success', text: `${total} ${total === 1 ? 'run' : 'runs'} queued successfully` };
  }
  if (succeeded === 0) {
    return { kind: 'error', text: `0 of ${total} ${total === 1 ? 'run' : 'runs'} queued; all failed`, failures };
  }
  return {
    kind: 'partial',
    text: `${succeeded} of ${total} ${total === 1 ? 'run' : 'runs'} queued; ${failed} failed`,
    failures,
  };
}
